import React from 'react';
import { ErrorBoundarySuspense } from '../../../../common/ui/error-boundary-suspense';
var LazyHeaderDropdownMenu = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_notification_headerDropdownMenu" */
  './main');
});
export default function HeaderDropdownMenu(props) {
  return /*#__PURE__*/React.createElement(ErrorBoundarySuspense, {
    errorFallback: /*#__PURE__*/React.createElement("div", null),
    loadingFallback: /*#__PURE__*/React.createElement("div", null),
    subjectId: "headerDropdownMenu"
  }, /*#__PURE__*/React.createElement(LazyHeaderDropdownMenu, props));
}